import { useQuery, DocumentNode } from "@apollo/client";

function useFlyerQuery(
  slug: string,
  FLYER_PDP_QUERY: DocumentNode
) {
  const cardQueryVariables = {
    slug: slug,
    version: "v2",
  };

  const { loading, error, data, previousData } = useQuery(FLYER_PDP_QUERY, {
    variables: cardQueryVariables,
  });

  const flyer = data?.flyer?.composition || previousData?.flyer?.composition;

  return { loading, error, flyer };
}

export default useFlyerQuery;
